import { connect } from 'react-redux';
import Uploader from '../components/Uploader';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Uploader);
